import React from "react";
import { Link } from "react-router-dom";

const serviceSteps = [
  {
    label: "Record",
    text: "Capture a short cry sample in the app.",
  },
  {
    label: "Analyze",
    text: "AI reads acoustic patterns in real time.",
  },
  {
    label: "Guide",
    text: "Caregivers get clear, practical next steps.",
  },
];

const serviceAdvantages = [
  {
    label: "8s+ sample",
    text: "Enough signal for better results.",
  },
  {
    label: "Live analysis",
    text: "Cry patterns interpreted in real time.",
  },
  {
    label: "Care guidance",
    text: "Simple next steps for calmer care.",
  },
];

export const Services = (props) => {
  const product = props.data?.[0];

  return (
    <section id="services" className="services-section">
      <div className="container services-shell">
        <div className="services-grid">
          <div className="services-app-preview">
            <div className="services-signal-field" aria-hidden="true">
              <span className="services-signal-ring services-ring-one" />
              <span className="services-signal-ring services-ring-two" />
              <span className="services-signal-ring services-ring-three" />
              <span className="services-signal-line services-line-one" />
              <span className="services-signal-line services-line-two" />
              <span className="services-signal-line services-line-three" />
            </div>

            <div className="services-phone-frame">
              <span className="services-phone-speaker" aria-hidden="true" />
              <img
                src="img/prototype/3.jpg"
                alt="LetBabyTalk analyzing a baby cry sample"
              />
              <span className="services-phone-home" aria-hidden="true" />
            </div>

            <div className="services-floating-feature services-feature-one">
              <strong>{serviceAdvantages[0].label}</strong>
              <p>{serviceAdvantages[0].text}</p>
            </div>
            <div className="services-floating-feature services-feature-two">
              <strong>{serviceAdvantages[1].label}</strong>
              <p>{serviceAdvantages[1].text}</p>
            </div>
            <div className="services-floating-feature services-feature-three">
              <strong>{serviceAdvantages[2].label}</strong>
              <p>{serviceAdvantages[2].text}</p>
            </div>
          </div>

          <div className="services-copy">
            <p className="section-kicker">Our Services</p>
            <h2>Understand baby cries with AI</h2>
            <p className="services-lede">
              LetBabyTalk records a cry sample, analyzes sound patterns, and
              turns the result into simple care guidance parents can act on.
            </p>

            <div className="services-flow-list" aria-label="How LetBabyTalk works">
              {serviceSteps.map((step, index) => (
                <div className="services-flow-step" key={step.label}>
                  <span>{`0${index + 1}`}</span>
                  <div>
                    <strong>{step.label}</strong>
                    <p>{step.text}</p>
                  </div>
                </div>
              ))}
            </div>

            {product && (
              <Link to={`/project/${product.id}`} className="services-link">
                Explore LetBabyTalk
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
